<template>
    <div>
        <UiHeroTop 
        :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />        
    </div>
  
    <!-- Change titles and blogs for shipping-->
    <div>      
        <template v-for="tag in getUniqueTags()"> 
            <ContentFaqSection :articles="blogStore.filterArticlesByTag(blog, tag)" :tag="tag" v-if="tag != 'Herobanner'"/>
        </template>
    </div>


    
</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();


// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

function getUniqueTags() {
  const tags = new Set();
  props.blog.articles.forEach(article => {
    if (article.tags) {
      article.tags.forEach(tag => tags.add(tag));
    }
  });
  return Array.from(tags);
}

// Prepare filtered FAQ articles for SEO
const faqArticles = computed(() => {
  return props.blog.articles.filter(article => {
    return article.tags && !article.tags.includes('Herobanner');
  }).map(article => ({
    title: article.title,
    content: article.content,
    handle: article.handle
  }));
});


</script>

<style scoped>
  .btn:hover {
    transform: scale(1.03); /* Slightly larger on hover */
  }
</style>